import ApiService, {callCustomMethodAsync}  from '../service/ApiService';

let moduleApi = {};
let moduleName = "project_member";

moduleApi.create = async (dataForm) => { 
  let api = {
     module: moduleName,
     type: "create",
     value: dataForm
   };
   const result = await ApiService(api);
   mushroom[moduleName].invalidCache();
   return result;
 };
 
 moduleApi.update = async (dataForm) => {
   let api = {
     module: moduleName,
     type: "partialUpdate",
     value: dataForm
   };
   const result = await ApiService(api);
   mushroom[moduleName].invalidCache();
   return result;
 };

 
moduleApi.list = async (dataFilter,loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: (loading == undefined ? false : loading ),
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};


moduleApi.delete = async (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: {id: id},
    message: {
        success: "", //string | null | comment
        error: "hidden", //string | null | comment
    },
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: {id: id}
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.GetProjectMembers = async (data) => {
  let api = {
    module: moduleName,
    type: "GetProjectMembers",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
  // data = {
  //  "ProjectId" : ""
  //}

  //result = {
  //    "ProjectMembers":[]{
  //        "UserId"
  //        "UserFullName"
 //         "AvataImageId"
 //         "Role"
  //     }
  //    
  //}
};


moduleApi.GetMembers = async (data) => {
  let api = {
    module: moduleName,
    type: "GetMembers",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.GetTaskAssigners = () => {
  let api = {
      module: moduleName,
      type: "GetTaskAssigners",
      message: {
        success: "hidden",
        error: "hidden",
      }
  };
  return callCustomMethodAsync(api);
};

export default moduleApi;
